// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ok-0";
export var buttonContainer = "_ok-3";
export var cancelButton = "_ok-4";
export var headerSection = "_ok-6";
export var headerTitle = "_ok-9";
export var messageSideLeft = "_ok-1";
export var messageSideRight = "_ok-2";
export var orderNumberContainer = "_ok-7";
export var orderNumberLabel = "_ok-8";
export var submitButton = "_ok-5";